/**
 * Utility Class to be used on NodeJS and Typescript that represent the Environment default values
 */
class LocalEnv {
  constructor() {
    this.API_URL = '/console/api/sync';
    this.LINK_API_URL = '/console/linkapi/sync';
    this.STARGATE_URL = '/console/portal/api';
    this.INTERNAL_API_URL = '/internal/console/api/sync';
    this.CONFIG_URL = '/console/config';
    this.USERS_API_URL = '/console/users';
    this.FORMS_API_URL = '/console/sync/forms';
    this.AUTH0_SCOPE = 'openid profile email';
    this.AUTH0_RESPONSE_TYPE = 'token id_token';
    this.AUTH0_RESPONSE_MODE = 'fragment';
    this.AUTH0_REDIRECT =
      'https://validation-internal.vixxo.com/console/callback';
    this.AUTH0_RETURN_URL = 'http://localhost';
    this.INTERNAL_API_SERVER = 'https://vixxo-api-staging.vixxo.com/v2';

    this.CLIENT_ID = '88feb6d0-ef92-4e3a-87b5-91092350a6ef';
    this.AUTHORITY =
      'https://vixxob2cdev.b2clogin.com/vixxob2cdev.onmicrosoft.com/b2c_1a_signin-vixxolink-validation/';
    this.KNOWNAUTHORITIES = 'vixxob2cdev.b2clogin.com';
    this.CACHELOCATION = 'localStorage';
    this.OPENIDSCOPES = 'openid';
    this.OFFLINE_ACCESS = 'offline_access';
    this.UNPROTECTEDRESOURCES = 'https://www.microsoft.com/en-us/';

    // ==============================================================================
    // =============================== Local ========================================
    // ==============================================================================
    // this.API_SERVER = 'http://localhost:8080/v2/sync';
    // this.Link_API_SERVER = 'http://localhost:8080/v2/sync/link';
    // this.AUTH0_CLIENT_ID = 'ysapzlf4tJh98b0zNSVLeY04LzcDorGc';
    // this.AUTH0_CLIENT_DOMAIN = 'vixxo-dev.auth0.com';
    // this.AUTH0_AUDIENCE = 'http://localhost:3000/';
    // this.X_API_KEY = 'BXkZ1omBSZ1LKtmjVKuh76sZUYa24gF521rTnnyd';
    // this.STARGATE_API_SERVER = 'http://localhost:5000/api';
    // this.USERS_API_SERVER = 'http://localhost:5000/v2/auth/api/graphql';
    // this.FORMS_API_SERVER = 'https://localhost:5001/v2/forms/api/graphql';

    // ==============================================================================
    // =============================== VALIDATION ===================================
    // ==============================================================================
    this.API_SERVER = 'https://validation-api.vixxo.com/v2';
    this.LINK_API_SERVER = 'https://validation-lb-api.vixxolink.com/api';
    this.AUTH0_CLIENT_ID = 'ysapzlf4tJh98b0zNSVLeY04LzcDorGc';
    this.AUTH0_CLIENT_DOMAIN = 'vixxo-dev.auth0.com';
    this.AUTH0_AUDIENCE = 'https://validation-api.vixxo.com/';
    this.X_API_KEY = 'AMaVhIUZDv7nmi8e7Dk0BaoaMRXvRRhc5MORttfr';
    this.STARGATE_API_SERVER = 'https://validation-internal.vixxo.com/api';
    this.USERS_API_SERVER = 'https://validation-api.vixxo.com/v2/auth';
    this.FORMS_API_SERVER = 'https://validation-api.vixxo.com/v2/forms/';
    // ==============================================================================
    // =============================== STAGING ======================================
    // ==============================================================================
    // this.API_SERVER = 'https://stagingapi.vixxo.com/v2';
    // this.LINK_API_SERVER = 'https://6smayjj6kg.execute-api.us-east-1.amazonaws.com/latest';
    // this.AUTH0_CLIENT_ID = 'ysapzlf4tJh98b0zNSVLeY04LzcDorGc';
    // this.AUTH0_CLIENT_DOMAIN = 'vixxo-dev.auth0.com';
    // this.AUTH0_AUDIENCE = 'https://stagingapi.vixxo.com';
    // this.X_API_KEY = 'BXkZ1omBSZ1LKtmjVKuh76sZUYa24gF521rTnnyd';
    // this.STARGATE_API_SERVER = 'http://staging-internal.vixxo.com/api';
    // this.USERS_API_SERVER = 'https://stagingapi.vixxo.com/v2/auth';
    // this.FORMS_API_SERVER = 'https://stagingapi.vixxo.com/v2/forms/';

    // ==============================================================================
    // =============================== PROD =========================================
    // ==============================================================================
    // this.API_SERVER = 'https://api.vixxo.com/v2';
    // this.LINK_API_SERVER = 'https://api.vixxolink.com/v2'
    // this.AUTH0_CLIENT_ID = 'Ooo6qMYke2Ti6xmGhYEQS8YHsH50yrRa';
    // this.AUTH0_CLIENT_DOMAIN = 'vixxo.auth0.com';
    // this.AUTH0_AUDIENCE = 'https://api.vixxo.com';
    // this.X_API_KEY = 'JFWYVIaCdh2paHzZ58iezahfkLsyhwDo8bMz65Q3';

    /* AUTHENTICATION TO CSV SCRIPT */
    this.STAGING_API_TEST_GRANT_TYPE = 'password';
    this.STAGING_API_TEST_CLIENT_ID = '9F1fYOc02zLUrdr7CIYW36l2aRrLD4iU';
    this.STAGING_API_TEST_USERNAME = 'test@tiempo.com';
    this.STAGING_API_TEST_PASSWORD = 'tiempo123';
    this.STAGING_API_TEST_SCOPE = 'openid profile email';
    this.STAGING_API_TEST_CLIENT_SECRET =
      'nAW9lnAl87EmbDplRHXk7hb3KFjCaIBtcalHF77pPYaGtXlvqQFrfuwyxfCPzk4e';
    this.STAGING_API_TEST_CLIENT_TOKEN_URL =
      'https://stagingapi.vixxo.com/latest/token';
    this.CONSOLE_LOG_INDEX = 'vixxo-logs-8.6.1';
  }
}

module.exports = new LocalEnv();
